export const escapeRegexCharacters = (string) => {
    const escapedString = string
        .replace(".", ".")
        .replace("^", "^")
        .replace("$", "$")
        .replace("*", "*")
        .replace("+", "+")
        .replace("-", "-")
        .replace("?", "?")
        .replace("(", "(")
        .replace("[", "[")
        .replace("]", "]")
        .replace("{", "{")
        .replace("{", "{")
        .replace("|", "|");
    return escapedString;
};
//# sourceMappingURL=escapeRegexCharacters.js.map
